import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium, getOtherIcons } from 'src/styles/font';
import { OtherIconsSet } from 'src/utils/constants/IconsConstants';

interface BackToAppWidgetProps {
  btnText: string;
  clickHandler: (e: Event) => void;
}

const backAppWidgetWrapper = css`
  padding-top: 16px;
`;

const buttonStyle = css`
  display: block;
  background: ${colors.ViWidgetBg};
  padding: 9px 16px;
  border: none;
  color: ${colors.white};
  cursor: pointer;
  text-align: left;
  width: 100%;
  ${ZeeFontMedium(14, 19)}
`;

const backArrowIcon = css`
  font-size: 0.875rem;
  line-height: 17px;
  float: left;
  margin-right: 10px;
  width: 7px;
  &:before {
    position: relative;
    left: -5px;
  }
  ${getOtherIcons(OtherIconsSet.LEFT_ARROW_CHEVRON)};
`;

const BackToAppWidget = (props: BackToAppWidgetProps) => {
  const { btnText, clickHandler } = props;
  return (
    <div data-testid="backAppWidget-wrapper" css={backAppWidgetWrapper}>
      <button
        type="button"
        css={buttonStyle}
        onClick={(e: any) => clickHandler(e)}
        data-testid="backAppWidget-btn">
        <span css={backArrowIcon} />
        <span>{btnText}</span>
      </button>
    </div>
  );
};

export default BackToAppWidget;
